import {createContext} from 'react'

const CatTipoVentaMostradorContext = createContext()

export default CatTipoVentaMostradorContext